import React from 'react';
import { RefreshCw } from 'lucide-react';

export function LogsPanel({ logs, onRefresh }) {
  return (
    <div className="panel-section">
      <button className="btn btn-ghost" onClick={onRefresh}>
        <RefreshCw size={14} />
        Refresh
      </button>
      {logs.length === 0 && <div className="muted">No invocations yet.</div>}
      <div className="log-list">
        {logs.map((log) => (
          <div key={log._id} className="log-row">
            <span className={`log-status log-status-${Math.floor(log.statusCode / 100)}xx`}>
              {log.statusCode}
            </span>
            <span>{log.method}</span>
            <span className="muted">{log.path}</span>
            <span className="muted">{log.durationMs}ms</span>
            <span className="muted">{new Date(log.createdAt).toLocaleString()}</span>
            {log.logs?.length > 0 && (
              <details>
                <summary>console output</summary>
                <pre>{log.logs.join('\n')}</pre>
              </details>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
